import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PublicRoutes } from './PublicRoutes';
import { AdminRoutes } from './AdminRoutes';
import { TenantRoutes } from './TenantRoutes';
import { TenantNotFound } from '@/pages/TenantNotFound';
import { AppNotFound } from '@/pages/AppNotFound';
import { isAppSubdomain } from '@/utils/domainDetection';

/**
 * Componente principal que organiza todas as rotas da aplicação
 * Ordem importa: rotas específicas devem vir antes das genéricas
 */
export const AppRoutes = () => {
  const isApp = isAppSubdomain();

  return (
    <Routes>
      {/* Rotas públicas (/, /auth, /properties, etc) */}
      {PublicRoutes()}

      {/* Rotas admin (/admin/*) - DEVEM VIR ANTES das rotas multitenant */}
      {AdminRoutes()}

      {/* Se não for o subdomínio app.imobpanda.com, podemos renderizar rotas de tenant */}
      {!isApp && (
        <>
          {/* Rotas multitenant (/:tenantSlug/*) - DEVEM VIR POR ÚLTIMO */}
          {TenantRoutes()}

          {/* Rota genérica para suporte a localhost (ex: localhost:8080/nome-tenant) */}
          <Route
            path="/:tenantSlug/*"
            element={
              <Routes>
                {TenantRoutes()}
              </Routes>
            }
          />
        </>
      )}

      {/* Fallback para rotas não encontradas */}
      <Route path="*" element={isApp ? <AppNotFound /> : <TenantNotFound />} />
    </Routes>
  );
};
